'use strict';

bbw.guest.ProfileCtrl = bbw.shared.ProfileCtrl.extend({

});
